import { render, staticRenderFns } from "./subjectsDrawer.vue?vue&type=template&id=3daddf8a&scoped=true"
import script from "./subjectsDrawer.vue?vue&type=script&lang=js"
export * from "./subjectsDrawer.vue?vue&type=script&lang=js"
import style0 from "./subjectsDrawer.vue?vue&type=style&index=0&id=3daddf8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daddf8a",
  null
  
)

export default component.exports